/**
 * Visibilidade LOCAL (por usuário/navegador) no mapa: ícones de sensor por
 * tipo de equipamento (default ocultos) e os tipos de equipamento/hubs
 * (default visíveis).
 */

import {
  TIPOS_ICONE_MAPA,
  visibilidadeIconesPadrao,
} from '@/utils/sensorMapaIcons'

const chave = (localId) => `flow.mapa-sensor-icones.visiveis.${localId}`
const chaveEquipamentos = (localId) =>
  `flow.mapa-equipamentos.visiveis.${localId}`
const chaveTiposEquipamento = (localId) =>
  `flow.mapa-equipamentos.tipos.visiveis.${localId}`

const IDS_TIPO_EQUIPAMENTO = [0, 1]

const idsValidos = new Set(TIPOS_ICONE_MAPA.map((tipo) => tipo.id))

function mapaIconesPadrao() {
  return visibilidadeIconesPadrao()
}

function aplicarLigados(mapa, ligados) {
  if (!Array.isArray(ligados)) {
    return
  }

  ligados.forEach((id) => {
    if (idsValidos.has(id)) {
      mapa[id] = true
    }
  })
}

function ligadosDoMapa(mapa) {
  return TIPOS_ICONE_MAPA.map((tipo) => tipo.id).filter(
    (id) => mapa && mapa[id] === true
  )
}

// A lista antiga (um único conjunto de ícones) vale para os dois tipos até
// o usuário gravar a preferência separada.
export function carregarIconesSensorVisiveis(localId) {
  const porTipo = {
    0: mapaIconesPadrao(),
    1: mapaIconesPadrao(),
  }

  try {
    const bruto = localStorage.getItem(chave(localId))
    if (!bruto) {
      return porTipo
    }

    const gravado = JSON.parse(bruto)
    if (Array.isArray(gravado)) {
      IDS_TIPO_EQUIPAMENTO.forEach((tipo) => {
        aplicarLigados(porTipo[tipo], gravado)
      })
      return porTipo
    }

    IDS_TIPO_EQUIPAMENTO.forEach((tipo) => {
      aplicarLigados(porTipo[tipo], gravado && gravado[tipo])
    })
  } catch {
    // JSON corrompido / localStorage indisponível: começa com o default.
  }

  return porTipo
}

export function gravarIconesSensorVisiveis(localId, porTipo) {
  const gravado = {}
  let algum = false
  IDS_TIPO_EQUIPAMENTO.forEach((tipo) => {
    const ligados = ligadosDoMapa(porTipo[tipo])
    gravado[tipo] = ligados
    if (ligados.length > 0) {
      algum = true
    }
  })

  try {
    if (!algum) {
      localStorage.removeItem(chave(localId))
      return
    }

    localStorage.setItem(chave(localId), JSON.stringify(gravado))
  } catch {
    // localStorage cheio/indisponível: o ajuste só não sobrevive ao reload.
  }
}

function tiposEquipamentoPadrao() {
  return { 0: true, 1: true }
}

// Tipos de equipamento no mapa: default ligado. A chave antiga (um único
// "off" para todos os hubs) vale só quando ainda não há preferência por tipo.
export function carregarTiposEquipamentoVisiveis(localId) {
  const visiveis = tiposEquipamentoPadrao()

  try {
    const bruto = localStorage.getItem(chaveTiposEquipamento(localId))
    if (bruto) {
      const gravado = JSON.parse(bruto)
      IDS_TIPO_EQUIPAMENTO.forEach((id) => {
        if (gravado && gravado[id] === false) {
          visiveis[id] = false
        }
      })
      return visiveis
    }

    if (localStorage.getItem(chaveEquipamentos(localId)) === '0') {
      IDS_TIPO_EQUIPAMENTO.forEach((id) => {
        visiveis[id] = false
      })
    }
  } catch {
    // JSON corrompido / localStorage indisponível: começa com o default.
  }

  return visiveis
}

export function gravarTiposEquipamentoVisiveis(localId, visiveis) {
  const todosLigados = IDS_TIPO_EQUIPAMENTO.every(
    (id) => visiveis[id] !== false
  )

  try {
    localStorage.removeItem(chaveEquipamentos(localId))
    if (todosLigados) {
      localStorage.removeItem(chaveTiposEquipamento(localId))
      return
    }

    const gravado = {}
    IDS_TIPO_EQUIPAMENTO.forEach((id) => {
      gravado[id] = visiveis[id] !== false
    })
    localStorage.setItem(
      chaveTiposEquipamento(localId),
      JSON.stringify(gravado)
    )
  } catch {
    // localStorage cheio/indisponível: o ajuste só não sobrevive ao reload.
  }
}
